import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = {
  key: 0,
  class: "widget px-8 py-7"
}
const _hoisted_3 = {
  key: 1,
  class: "widget px-8 py-7"
}
const _hoisted_4 = { class: "text-red" }
const _hoisted_5 = { class: "s20 widget px-6 pt-8 pb-2 mb-6" }
const _hoisted_6 = { class: "s20 gap-6 px-5 pb-8" }
const _hoisted_7 = { class: "flex items-center gap-6" }
const _hoisted_8 = { class: "s7" }
const _hoisted_9 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_10 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_11 = { class: "s7" }
const _hoisted_12 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_13 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_14 = { class: "s6" }
const _hoisted_15 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_16 = { class: "s20 widget px-6 pt-8 pb-2 mb-6" }
const _hoisted_17 = { class: "s20 items-center gap-6 px-0 pb-6" }
const _hoisted_18 = { class: "px-5 mt-3" }
const _hoisted_19 = { class: "s10" }
const _hoisted_20 = { class: "secondary-font gap-4 mt-2 mb-4" }
const _hoisted_21 = { class: "s10 font-medium pl-8" }
const _hoisted_22 = { class: "text-4xl font-bold ml-2" }
const _hoisted_23 = { class: "s10 form-field-split my-4" }
const _hoisted_24 = { class: "form-field-floating lg active half" }
const _hoisted_25 = ["value"]
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "form-field-floating lg reactive half" }
const _hoisted_28 = { class: "s10_mobile pl-8" }
const _hoisted_29 = { class: "custom-upload-st2" }
const _hoisted_30 = { class: "s12" }
const _hoisted_31 = { class: "custom-upload-text" }
const _hoisted_32 = { class: "custom-upload-text" }
const _hoisted_33 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_34 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_35 = { class: "text-3xl font-bold position-absolute" }
const _hoisted_36 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","justify-content":"end"}
}
const _hoisted_37 = {
  key: 0,
  class: "text-red mr-4"
}
const _hoisted_38 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between","margin-bottom":"10px"} }
const _hoisted_39 = { class: "text-red" }
const _hoisted_40 = { class: "table separator skin1" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "font-bold text-xl" }
const _hoisted_44 = { class: "font-bold text-xl" }
const _hoisted_45 = { class: "font-bold" }
const _hoisted_46 = { class: "text-sm text-grey-500" }
const _hoisted_47 = { class: "text-sm text-grey-500" }
const _hoisted_48 = { class: "tag-state warning stroke" }
const _hoisted_49 = { class: "flex-right" }
const _hoisted_50 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_51 = { class: "s20 items-center gap-6 px-0 pb-6" }
const _hoisted_52 = { class: "s20 flex gap-3 mb-7" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "flex items-center px-5 gap-6" }
const _hoisted_55 = { class: "s7" }
const _hoisted_56 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_57 = { class: "s7" }
const _hoisted_58 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_59 = { class: "s6" }
const _hoisted_60 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_61 = { class: "table separator skin3 sm rounded" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "flex align-items-center" }
const _hoisted_65 = {
  class: "square-xl rounded-15",
  style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
}
const _hoisted_66 = ["src"]
const _hoisted_67 = { style: {"width":"20%"} }
const _hoisted_68 = { class: "text-xl font-semibold mb-2" }
const _hoisted_69 = {
  style: {"width":"15%"},
  class: "text-xl font-semibold mb-2"
}
const _hoisted_70 = {
  key: 0,
  class: "widget s20 border border-3 active shadow-200 rounded-30 gap-5 px-7 pt-4 pb-2 scale-0-8-5"
}
const _hoisted_71 = { class: "s10" }
const _hoisted_72 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_73 = { class: "secondary-font font-semibold text-grey-900 py-1" }
const _hoisted_74 = { class: "s10 text-right" }
const _hoisted_75 = { class: "mb-4" }
const _hoisted_76 = { class: "tag-state notif stroke" }
const _hoisted_77 = { class: "secondary-font font-semibold text-grey-600 pt-1 mb-4" }
const _hoisted_78 = {
  key: 1,
  class: "widget s20 border border-3 shadow-200 rounded-30 gap-5 px-7 pt-4 pb-2 scale-0-8-5"
}
const _hoisted_79 = { class: "s10" }
const _hoisted_80 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_81 = { class: "secondary-font font-semibold text-grey-900 py-1" }
const _hoisted_82 = { class: "s10 text-right" }
const _hoisted_83 = { class: "mb-4" }
const _hoisted_84 = {
  key: 0,
  class: "tag-state danger stroke"
}
const _hoisted_85 = {
  key: 1,
  class: "tag-state success stroke"
}
const _hoisted_86 = { class: "secondary-font font-semibold text-grey-600 py-1" }
const _hoisted_87 = {
  key: 1,
  class: "widget s20 border border-3 shadow-200 rounded-30 gap-5 px-7 pt-4 pb-2 scale-0-8-5"
}
const _hoisted_88 = { style: {"display":"flex","flex-direction":"row","justify-content":"center"} }

import { ref, reactive, computed, onMounted } from 'vue'
import { formatAmount, AMOUNT_FORMAT_CONFIG } from '@/utils/formatters'
import prelevementService from '@/services/prelevementService'
import type { Periode, PrelevementItem, DecaissementUser } from '@/services/prelevementService'

// State

export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesRecouvrement',
  setup(__props) {

const initialLoading = ref(true)
const startupError = ref('')

// Wallet
const walletInfos = reactive({
  total_montant_decaissements: 0,
  last_montant_decaissement: 0,
  total_montant_prelevements: 0,
  solde: 0
})

// Prélèvements
const periodes = ref<Periode[]>([])
const prelevementsList = ref<PrelevementItem[]>([])
const loadingPrelevements = ref(false)
const savingPrelevement = ref(false)
const validatingPrelevement = ref(false)
const saveError = ref('')
const validateError = ref('')
const prelevementStats = reactive({
  montant_prelevement_expected: 0
})

const formData = reactive({
  periode: null as Periode | null,
  montant_prelevement: 0,
  file: null as File | null,
  file_name: ''
})

// Décaissements
const decaissementPeriode = ref<Periode | null>(null)
const decaissementUsers = ref<DecaissementUser[]>([])
const decaissementPage = ref(1)
const loadingDecaissements = ref(false)
const decaissementStats = reactive({
  montant_decaissement: 0,
  montant_prelevement: 0,
  montant_prelevement_expected: 0,
  solde: 0
})

// Computed
const isFormValid = computed(() => {
  return formData.montant_prelevement > 0 && !!formData.file_name
})

const prelevementPercentage = computed(() => {
  if (!formData.montant_prelevement || !prelevementStats.montant_prelevement_expected) return 0
  return Math.min(100, Math.round((formData.montant_prelevement / prelevementStats.montant_prelevement_expected) * 100))
})

const soldePercentage = computed(() => {
  if (!walletInfos.total_montant_prelevements) return 0
  return Math.min(100, Math.round((walletInfos.solde / walletInfos.total_montant_prelevements) * 100))
})

const decaissementPercentage = computed(() => {
  if (!walletInfos.total_montant_prelevements) return 0
  return Math.min(100, Math.round((walletInfos.total_montant_decaissements / walletInfos.total_montant_prelevements) * 100))
})

const decaissementUsersPaginated = computed(() => {
  const start = (decaissementPage.value - 1) * 10
  return decaissementUsers.value.slice(start, start + 10)
})

// Init
onMounted(async () => {
  try {
    const data = await prelevementService.getStartupInfos()
    periodes.value = data.periodes
    formData.periode = data.periodes.find((p: Periode) => p.selected) || data.periodes[0] || null
    decaissementPeriode.value = formData.periode

    await Promise.all([
      loadWalletInfos(),
      loadPrelevementsInfos(),
      loadDecaissementInfos()
    ])
  } catch (error: any) {
    startupError.value = error.message || 'Erreur lors du chargement'
  } finally {
    initialLoading.value = false
  }
})

async function loadWalletInfos() {
  try {
    const data = await prelevementService.getWalletInfos()
    Object.assign(walletInfos, data)
  } catch (error: any) {
    console.error('Erreur wallet:', error)
  }
}

async function loadPrelevementsInfos() {
  if (!formData.periode) return
  try {
    loadingPrelevements.value = true
    const data = await prelevementService.getPrelevementsInfos(formData.periode.value)
    prelevementsList.value = data.prelevements
    prelevementStats.montant_prelevement_expected = data.montant_prelevement_expected
  } catch (error: any) {
    console.error('Erreur prélèvements:', error)
  } finally {
    loadingPrelevements.value = false
  }
}

async function loadDecaissementInfos() {
  if (!decaissementPeriode.value) return
  try {
    loadingDecaissements.value = true
    const data = await prelevementService.getDecaissementInfos(decaissementPeriode.value.value)
    decaissementUsers.value = data.users
    decaissementStats.montant_decaissement = data.montant_decaissement
    decaissementStats.montant_prelevement = data.montant_prelevement
    decaissementStats.montant_prelevement_expected = data.montant_prelevement_expected
    decaissementStats.solde = data.solde
    decaissementPage.value = 1
  } catch (error: any) {
    console.error('Erreur décaissements:', error)
  } finally {
    loadingDecaissements.value = false
  }
}

function onSelectPeriode(event: Event) {
  const target = event.target as HTMLSelectElement
  const selected = periodes.value.find(p => p.value === target.value)
  if (selected) {
    formData.periode = selected
    loadPrelevementsInfos()
  }
}

function onSelectDecaissementPeriode(periode: Periode) {
  decaissementPeriode.value = periode
  loadDecaissementInfos()
}

function onFileUploaded(event: Event) {
  const target = event.target as HTMLInputElement
  if (target.files && target.files.length > 0) {
    formData.file = target.files[0]
    formData.file_name = target.files[0].name
    target.value = ''
  }
}

async function onSubmitPrelevement() {
  if (!formData.periode || formData.montant_prelevement <= 0) return
  savingPrelevement.value = true
  saveError.value = ''
  try {
    await prelevementService.savePrelevement({
      periode_prelevement: formData.periode.value,
      montant_prelevement: formData.montant_prelevement,
      fichier_prelevement: formData.file
    })
    // Reset form
    formData.montant_prelevement = 0
    formData.file = null
    formData.file_name = ''
    // Reload data
    await Promise.all([loadPrelevementsInfos(), loadWalletInfos()])
  } catch (error: any) {
    saveError.value = error.message
  } finally {
    savingPrelevement.value = false
  }
}

async function doValidatePrelevement(prelevement: PrelevementItem) {
  if (!window.confirm('Voulez-vous vraiment valider ce prélèvement ?')) return
  validatingPrelevement.value = true
  validateError.value = ''
  try {
    await prelevementService.validatePrelevement(prelevement.id)
    await Promise.all([loadPrelevementsInfos(), loadWalletInfos()])
  } catch (error: any) {
    validateError.value = error.message
  } finally {
    validatingPrelevement.value = false
  }
}

function onDecaissementPaginate(page: number) {
  decaissementPage.value = page
}

return (_ctx: any,_cache: any) => {
  const _component_money3 = _resolveComponent("money3")!
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[48] || (_cache[48] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-6" }, "Recouvrement", -1)),
    (initialLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("div", { style: {"display":"flex","justify-content":"center"} }, [
            _createElementVNode("div", { class: "loader dark" })
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (startupError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(startupError.value), 1)
        ]))
      : _createCommentVNode("", true),
    (!initialLoading.value && !startupError.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5" }, [
              _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, " Wallet / Décaissement ")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                    _createElementVNode("div", { class: "circle-medium bg-color-black" }),
                    _createTextVNode(" Solde ")
                  ], -1)),
                  _createElementVNode("h1", _hoisted_9, _toDisplayString(_unref(formatAmount)(walletInfos.solde)) + " F", 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-black",
                      style: _normalizeStyle({ width: soldePercentage.value + '%' })
                    }, _toDisplayString(soldePercentage.value) + "% ", 5)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                    _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
                    _createTextVNode(" Montant Décaissé ")
                  ], -1)),
                  _createElementVNode("h1", _hoisted_12, _toDisplayString(_unref(formatAmount)(walletInfos.total_montant_decaissements)) + " F", 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
                      style: _normalizeStyle({ width: decaissementPercentage.value + '%' })
                    }, _toDisplayString(decaissementPercentage.value) + "% ", 5)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                    _createElementVNode("div", { class: "circle-medium bg-green-light" }),
                    _createTextVNode(" Dernier décaissement ")
                  ], -1)),
                  _createElementVNode("h1", _hoisted_15, _toDisplayString(_unref(formatAmount)(walletInfos.last_montant_decaissement)) + " F", 1),
                  _cache[7] || (_cache[7] = _createElementVNode("div", {
                    class: "h-40 rounded-100 position-relative overflow-hidden",
                    style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
                  }, [
                    _createElementVNode("div", {
                      class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                      style: {"width":"0%"}
                    }, " 0% ")
                  ], -1))
                ])
              ])
            ])
          ]),
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
          _createElementVNode("div", _hoisted_16, [
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5" }, [
              _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, " Gérer les prélèvements ")
            ], -1)),
            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h2", _hoisted_20, " Charger le fichier de prélèvement de " + _toDisplayString(formData.periode ? formData.periode.label : ''), 1),
                  _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mb-2" }, "Format de fichier supporté: PDF. Taille max: 50MB.", -1))
                ]),
                _createElementVNode("h2", _hoisted_21, [
                  _cache[11] || (_cache[11] = _createTextVNode(" Montant à recevoir ", -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(formatAmount)(prelevementStats.montant_prelevement_expected)) + " F CFA", 1)
                ]),
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("select", {
                      class: "form-input-select",
                      value: formData.periode?.value,
                      onChange: onSelectPeriode
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodes.value, (p) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: p.value,
                          key: p.value
                        }, _toDisplayString(p.label), 9, _hoisted_26))
                      }), 128))
                    ], 40, _hoisted_25),
                    _cache[13] || (_cache[13] = _createElementVNode("label", null, [
                      _createTextVNode("Sélectionner une période "),
                      _createElementVNode("b", { class: "color-danger" }, "*")
                    ], -1))
                  ]),
                  _cache[16] || (_cache[16] = _createElementVNode("hr", { class: "hr" }, null, -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_money3, _mergeProps({
                      class: "form-input",
                      modelValue: formData.montant_prelevement,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.montant_prelevement) = $event))
                    }, _unref(AMOUNT_FORMAT_CONFIG)), null, 16, ["modelValue"]),
                    _cache[14] || (_cache[14] = _createElementVNode("label", null, "Montant du virement", -1)),
                    _cache[15] || (_cache[15] = _createElementVNode("span", null, "F CFA", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", {
                    for: "file-prelevement",
                    class: _normalizeClass(["mt-4 custom-upload", { active: formData.file }])
                  }, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("input", {
                        id: "file-prelevement",
                        class: "display-none",
                        type: "file",
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (onFileUploaded($event))),
                        accept: ".pdf"
                      }, null, 32),
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "s4 custom-upload-img" }, ".PDF", -1)),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("span", _hoisted_31, _toDisplayString(formData.file_name ? formData.file_name : 'Charger le fichier'), 1),
                        _cache[17] || (_cache[17] = _createTextVNode()),
                        _cache[18] || (_cache[18] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
                        _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(formData.file_name ? 'Doc chargé' : 'Uploader le doc'), 1)
                      ]),
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "s4 right" }, [
                        _createElementVNode("img", {
                          src: "/icons/icon-upload.svg",
                          class: "custom-upload-icon"
                        })
                      ], -1))
                    ])
                  ], 2)
                ]),
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1)),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, _toDisplayString(prelevementPercentage.value) + "%", 1),
                  _createElementVNode("div", {
                    class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-yellow",
                    style: _normalizeStyle({ width: prelevementPercentage.value + '%' })
                  }, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(formatAmount)(formData.montant_prelevement)) + " F / " + _toDisplayString(_unref(formatAmount)(prelevementStats.montant_prelevement_expected)) + " F", 1)
                  ], 4)
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
                (isFormValid.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      (!!saveError.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(saveError.value), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_custom_button, {
                        type: "button",
                        classesList: 'btn lg py-5 black',
                        loading: savingPrelevement.value,
                        onClick: onSubmitPrelevement
                      }, {
                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createElementVNode("span", null, "Télécharger le fichier de prélèvement", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading"])
                    ]))
                  : _createCommentVNode("", true),
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(validateError.value), 1),
                _createElementVNode("button", {
                  onClick: loadPrelevementsInfos,
                  class: "btn black normal justify-content-center mx-0 btn-filtre"
                }, [...(_cache[27] || (_cache[27] = [
                  _createElementVNode("img", {
                    src: "/icons/icon-scan.svg",
                    class: "btn-icon",
                    alt: ""
                  }, null, -1),
                  _createElementVNode("span", null, "Actualiser", -1)
                ]))])
              ]),
              _createElementVNode("table", _hoisted_40, [
                _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th"),
                    _createElementVNode("th", null, "Période"),
                    _createElementVNode("th", null, "Montant"),
                    _createElementVNode("th", null, "Fichier"),
                    _createElementVNode("th", null, "Date"),
                    _createElementVNode("th", null, "Etat"),
                    _createElementVNode("th")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (loadingPrelevements.value)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [...(_cache[28] || (_cache[28] = [
                        _createElementVNode("td", {
                          colspan: "7",
                          class: "text-center py-5"
                        }, [
                          _createElementVNode("div", { style: {"display":"flex","justify-content":"center"} }, [
                            _createElementVNode("div", { class: "loader dark" })
                          ])
                        ], -1)
                      ]))]))
                    : (prelevementsList.value.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [...(_cache[29] || (_cache[29] = [
                          _createElementVNode("td", {
                            colspan: "7",
                            class: "text-center py-5"
                          }, " Aucun fichier de prélèvement trouvé. ", -1)
                        ]))]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(prelevementsList.value, (prelevement, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "text-grey-700 over-effect",
                            key: 'prelevement_' + index
                          }, [
                            _cache[31] || (_cache[31] = _createElementVNode("td", { class: "font-black" }, [
                              _createElementVNode("img", {
                                src: "/icons/icon-data.svg",
                                class: "size-medium"
                              })
                            ], -1)),
                            _createElementVNode("td", _hoisted_43, _toDisplayString(prelevement.periode_prelevement_formatted), 1),
                            _createElementVNode("td", _hoisted_44, _toDisplayString(_unref(formatAmount)(prelevement.montant_prelevement)) + " F CFA", 1),
                            _createElementVNode("td", _hoisted_45, [
                              _createElementVNode("a", null, _toDisplayString(prelevement.fichier_prelevement), 1)
                            ]),
                            _createElementVNode("td", _hoisted_46, _toDisplayString(prelevement.created_at_formatted), 1),
                            _createElementVNode("td", _hoisted_47, [
                              _createElementVNode("span", _hoisted_48, _toDisplayString(prelevement.status_prelevement_label), 1)
                            ]),
                            _createElementVNode("td", _hoisted_49, [
                              (prelevement.status_prelevement === 'pending')
                                ? (_openBlock(), _createBlock(_component_custom_button, {
                                    key: 0,
                                    type: "button",
                                    onClick: ($event: any) => (doValidatePrelevement(prelevement)),
                                    classesList: 'btn-ultra',
                                    loading: validatingPrelevement.value
                                  }, {
                                    default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                      _createElementVNode("img", {
                                        src: "/icons/icon-valider.svg",
                                        class: "btn-icon",
                                        alt: ""
                                      }, null, -1),
                                      _createElementVNode("span", null, "Valider", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick", "loading"]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                ])
              ])
            ])
          ]),
          _cache[47] || (_cache[47] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
          _createElementVNode("div", _hoisted_50, [
            _cache[44] || (_cache[44] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5" }, [
              _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, " Prélèvements / Décaissements ")
            ], -1)),
            _cache[45] || (_cache[45] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodes.value, (p, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["btn", { light: p.value === decaissementPeriode.value?.value, light2: p.value !== decaissementPeriode.value?.value }]),
                    onClick: ($event: any) => (onSelectDecaissementPeriode(p)),
                    key: 'dec_periode_' + index
                  }, _toDisplayString(p.label), 11, _hoisted_53))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _cache[35] || (_cache[35] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                    _createElementVNode("div", { class: "circle-medium bg-pop-yellow" }),
                    _createTextVNode(" Montant prélevé ")
                  ], -1)),
                  _createElementVNode("h1", _hoisted_56, _toDisplayString(_unref(formatAmount)(decaissementStats.montant_prelevement)) + " F", 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _cache[36] || (_cache[36] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                    _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
                    _createTextVNode(" Montant décaissé ")
                  ], -1)),
                  _createElementVNode("h1", _hoisted_58, _toDisplayString(_unref(formatAmount)(decaissementStats.montant_decaissement)) + " F", 1)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _cache[37] || (_cache[37] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                    _createElementVNode("div", { class: "circle-medium bg-green-light" }),
                    _createTextVNode(" Montant à prélever ")
                  ], -1)),
                  _createElementVNode("h1", _hoisted_60, _toDisplayString(_unref(formatAmount)(decaissementStats.montant_prelevement_expected)) + " F", 1)
                ])
              ]),
              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
              _createElementVNode("table", _hoisted_61, [
                _cache[42] || (_cache[42] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th"),
                    _createElementVNode("th", null, "Information"),
                    _createElementVNode("th", null, "Collectivité"),
                    _createElementVNode("th", null, "Prélèvement"),
                    _createElementVNode("th", null, "Décaissement")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (loadingDecaissements.value)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_62, [...(_cache[38] || (_cache[38] = [
                        _createElementVNode("td", {
                          colspan: "5",
                          class: "text-center py-5"
                        }, [
                          _createElementVNode("div", { style: {"display":"flex","justify-content":"center"} }, [
                            _createElementVNode("div", { class: "loader dark" })
                          ])
                        ], -1)
                      ]))]))
                    : (decaissementUsers.value.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_63, [...(_cache[39] || (_cache[39] = [
                          _createElementVNode("td", {
                            colspan: "5",
                            class: "text-center py-5"
                          }, "Aucun membre trouvé.", -1)
                        ]))]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(decaissementUsersPaginated.value, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "text-grey-700 over-effect",
                            key: item.id
                          }, [
                            _createElementVNode("td", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("img", {
                                  src: item.photo ? item.photo : '/assets/users_avatar/600w/user.jpg',
                                  width: "100%"
                                }, null, 8, _hoisted_66)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_67, [
                              _createElementVNode("p", _hoisted_68, _toDisplayString(item.nom + ' ' + item.prenom), 1)
                            ]),
                            _createElementVNode("td", _hoisted_69, _toDisplayString(item.collectivite_nom), 1),
                            _createElementVNode("td", null, [
                              (item.prelevement_id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                    _createElementVNode("div", _hoisted_71, [
                                      _createElementVNode("h6", _hoisted_72, _toDisplayString(item.prelevement_periode_prelevement_formatted), 1),
                                      _createElementVNode("h3", _hoisted_73, _toDisplayString(_unref(formatAmount)(item.prelevement_montant_prelevement)) + " F", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_74, [
                                      _createElementVNode("div", _hoisted_75, [
                                        _createElementVNode("span", _hoisted_76, _toDisplayString(item.status_prelevement_label), 1)
                                      ]),
                                      _createElementVNode("h6", _hoisted_77, "Le " + _toDisplayString(item.prelevement_created_at_formatted), 1)
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_78, [...(_cache[40] || (_cache[40] = [
                                    _createElementVNode("div", { class: "s20 text-center" }, "Aucun prélèvement", -1)
                                  ]))]))
                            ]),
                            _createElementVNode("td", null, [
                              (item.souscription_id)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["widget s20 border border-3 shadow-200 rounded-30 gap-5 px-7 pt-4 pb-2 scale-0-8-5", { active: item.souscription_statut === 'done' }])
                                  }, [
                                    _createElementVNode("div", _hoisted_79, [
                                      _createElementVNode("h6", _hoisted_80, _toDisplayString(item.souscription_date_prevision_formatted), 1),
                                      _createElementVNode("h3", _hoisted_81, _toDisplayString(_unref(formatAmount)(item.souscription_pouvoir_achat)) + " F", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_82, [
                                      _createElementVNode("div", _hoisted_83, [
                                        (item.souscription_statut === 'pending')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_84, "En attente"))
                                          : _createCommentVNode("", true),
                                        (item.souscription_statut === 'done')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_85, "Effectué"))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("h6", _hoisted_86, _toDisplayString(item.souscription_created_at_formatted), 1)
                                    ])
                                  ], 2))
                                : (_openBlock(), _createElementBlock("div", _hoisted_87, [...(_cache[41] || (_cache[41] = [
                                    _createElementVNode("div", { class: "s20 text-center" }, "Aucun décaissement", -1)
                                  ]))]))
                            ])
                          ]))
                        }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createVNode(_component_custom_pagination, {
                  modelValue: decaissementPage.value,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((decaissementPage).value = $event)),
                    onDecaissementPaginate
                  ],
                  total: decaissementUsers.value.length,
                  "per-page": 10,
                  last_page: Math.ceil(decaissementUsers.value.length / 10)
                }, null, 8, ["modelValue", "total", "last_page"])
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})